import React, { Component } from 'react'

import './separator.scss'

class Separator extends Component {
	render() {
		const classes = ['vbui--separator', this.props.classes].join(' ')
		return (
			<div style={this.props.style} className={classes}>
				{this.props.children}
			</div>
		)
	}
}

export default Separator
